import React from 'react';
import { Helmet } from 'react-helmet';
import axios from "axios";
import Cookie from "../../assets/js/utils/Cookie";
import Api from "../../assets/js/utils/Api";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import CustomFileUpload from "../components/CustomFileUpload/CustomFileUpload.jsx";
import Button from "../components/CustomButtons/Button";
import BackgroundSlider from "../components/Slider/BackgroundSlider";
import successGif from '../../assets/img/success.gif';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import RichTextEditor from 'react-rte';
import GridItem from "../components/Grid/GridItem";
import GridContainer from "../components/Grid/GridContainer.jsx";
import fileicon from "../../assets/img/fileicon.png";
import foldericon from "../../assets/img/foldericon.png";
import withStyles from "@material-ui/core/styles/withStyles";
import homePageStyle from "../../assets/jss/material-kit-pro-react/views/homePageStyle.jsx";
import { helper } from '../../assets/js/utils/Element';
import CustomInput from "../components/CustomInput/CustomInput.jsx";
import { RichUtils } from 'draft-js';
import DateTimePicker from "../components/CustomInput/DateTimePicker";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";
import ZipConfirmationModal from "../components/User/ZipConfirmationModal";
import MaterialIcon from "@mdi/react";
import { mdiAccountGroup } from '@mdi/js';
import ConfirmationModal from "../components/User/ConfirmationModal";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import LoaderComponent from "../components/Loader";
import SendLimitModal from '../components/User/SendLimitModal';
import Config from "../../../Config";
import FarApi from "../../assets/js/utils/far/farApi";
import { evaluateSend, buildFarSendPayload, describeExclusion, FAR_DEFAULT_SETTINGS, FAR_ENFORCEMENT, FAR_STATE } from "../../assets/js/utils/far/farEngine";
import { isFarEnabled, isFarAdmin } from "../components/User/Far/farAccess";
import FarStatusBanner from "../components/User/Far/FarStatusBanner";
import FarCheckPanel from "../components/User/Far/FarCheckPanel";
import FarFileStatus from "../components/User/Far/FarFileStatus";
import FarExceptionModal from "../components/User/Far/FarExceptionModal";
import sendPageStyle from "../../assets/jss/user/far/sendPageStyle.jsx";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import BlockIcon from "@material-ui/icons/Block";
import SecurityIcon from "@material-ui/icons/Security";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import AttachFile from "@material-ui/icons/AttachFile";
import ContactsOutlined from "@material-ui/icons/ContactsOutlined";
import AddressBookModal from "../components/User/Contacts/AddressBookModal.jsx";
import CloudUploadOutlined from "@material-ui/icons/CloudUploadOutlined";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import DescriptionOutlined from "@material-ui/icons/DescriptionOutlined";
import MyDocsPickerModal from "../components/User/MyDocs/MyDocsPickerModal.jsx";
import MyDocsApi, { commonFolder, parentFolder } from "../../assets/js/utils/myDocs/myDocsApi";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/** Keeps each My Docs pick once and drops picks that sit inside a picked folder. */
const dedupeMyDocsItems = (items) => {
    const seen = {};
    const folders = items.filter(item => item.type === "folder").map(item => item.path);
    return items.filter(item => {
        if(!item || seen[item.id]){
            return false;
        }
        seen[item.id] = true;
        return !folders.some(folder => item.path !== folder && String(item.path).indexOf(folder+"/") === 0);
    });
};

/** Readable text for a failed My Docs share (FAR 422, validation errors or a plain message). */
const shareErrorText = (err) => {
    if(!err){
        return "The secure link could not be created. Please try again.";
    }
    if(err.far && Array.isArray(err.far.messages) && err.far.messages.length > 0){
        return (err.message ? err.message+" " : "")+err.far.messages.join(" ");
    }
    if(typeof(err.message) === "string" && err.message){
        return err.message;
    }
    if(typeof(err) === "object"){
        const values = Object.values(err).filter(v => typeof(v) === "string");
        if(values.length > 0){
            return values.join(" ");
        }
    }
    return "The secure link could not be created. Please try again.";
};

const Home = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;
        this.editor = React.createRef();
        let yourEmail = Cookie.read("sendlinx_your_email");
        if(!yourEmail || yourEmail === "null"){
            yourEmail = "";
        }
        const { authorized, user, customState } = this.store.getState();
        if(authorized){
            yourEmail = user.email;
        }

        let transferType = "email";
        let success = false;
        let response = null;
        let resetComponent = false;
        if(customState !== null && customState.hasOwnProperty("type") && customState.type === 'send'){
            success = customState.hasOwnProperty("success") ? customState.success : success;
            response = customState.hasOwnProperty("response") ? customState.response : response;
            transferType = customState.hasOwnProperty("transferType") ? customState.transferType : transferType;
            resetComponent = true;
        }

        this.state = {
            emailTo: "",
            recipients: [],
            yourEmail: yourEmail,
            message: RichTextEditor.createEmptyValue(),
            transferType: transferType,
            showTransfer: false,
            files: [],
            scrollTo: 0,
            validation: {
                emailTo: "",
                yourEmail: ""                
            },
            uploading: false,
            response: response,
            success: success,
            cancelToken: null,
            maxSize: 2147483648,
            maxFileUploadSize: 107374182400,
            totalSize: 0,
            totalSent: 0,
            singleSent: 0,
            snackbarOpen: false,
            totalFiles: 0,
            showError: false,
            showPwnedError: false,
            errorMessage: "",
            chunkSize: (1048576 * 15), //15 MB by default
            resumable: false,
            resumableKey: 0,
            linkPassword: "",
            expire: null,
            requireVerification: false,
            zipUpload: false,
            zipPassword: "",
            zipPasswordToggle: false,
            showZipUploadCheckbox: false,
            zipCheckboxDisabledStatus: false,
            zipName: "SL_"+this.getDateString()+".zip",
            showZipConfirmationModal: true,
            zipConfirmationModal: false,
            zipConfirmationMessage: "",
            upgradeModal: false,
            viewPassword: false,
            viewZipPassword: false,
            resetComponent: resetComponent,
            checkingpwned: false,
            foundPwned: false,
            breachedEmails: [],
            pwnedSuccessMessage: '',
            sendLimitModal: false,
            expirePreset: null,
            dragOver: false,
            // File Attachment Rules (FAR)
            far: {
                active: false,
                loading: false,
                error: null,
                settings: FAR_DEFAULT_SETTINGS,
                rules: [],
                canOverride: false,
                isAdmin: false
            },
            farExceptions: {},
            farActions: [],
            farModal: null,
            farChecked: false,
            addressBookModal: false,
            addressBookView: "contacts",
            // Files source: "files" / "folder" upload from the computer, "mydocs" shares files already in Sendlinx.
            sourceTab: "files",
            myDocsItems: [],
            myDocsPicker: false,
            myDocsResolving: false,
            myDocsError: null,
            myDocsPending: false,
        };
        this.farSource = null;
        this.myDocsSource = null;
        this.uploaderRef = React.createRef();

        this.partNumber = 0;
        this.chunksSent = 0;
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.toggleTransfer = this.toggleTransfer.bind(this);
        this.onFilesSelect = this.onFilesSelect.bind(this);
        this.sendFiles = this.sendFiles.bind(this);
        this.onEmailKeyUp = this.onEmailKeyUp.bind(this);
        this.cancelUpload = this.cancelUpload.bind(this);
        this.sendAnother = this.sendAnother.bind(this);
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.copyDownloadLink = this.copyDownloadLink.bind(this);
        this.closeSnackbar = this.closeSnackbar.bind(this);
        this.onFileDelete = this.onFileDelete.bind(this);
        this.resumeUpload = this.resumeUpload.bind(this);
        this.beforeUnload = this.beforeUnload.bind(this);
        this.onUpgradeModal = this.onUpgradeModal.bind(this);
        this.onSendClick = this.onSendClick.bind(this);
        this.onFarResolve = this.onFarResolve.bind(this);
        this.onFarRemoveRecipients = this.onFarRemoveRecipients.bind(this);
        this.onAddressBook = this.onAddressBook.bind(this);
        this.onAddressBookAdd = this.onAddressBookAdd.bind(this);
        this.loadFarConfig = this.loadFarConfig.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onSourceSelect = this.onSourceSelect.bind(this);
        this.onMyDocsPicked = this.onMyDocsPicked.bind(this);
        this.sendMyDocs = this.sendMyDocs.bind(this);
        this.dispatchSend = this.dispatchSend.bind(this);
        this.backToForm = this.backToForm.bind(this);
    }
    componentDidUpdate(prevProps, prevState){
        this.cleanupEditorMarkup();
    }
    componentDidMount(){
        const { authorized, user } = this.store.getState();
        if(!authorized && this.history.location.pathname === "/"){
            this.history.push("/auth/login");
            return;
        }
        if(authorized && this.history.location.pathname === "/"){
            this.history.push(helper.getHomePageUrl(user));
            return <></>
        }
        this.cleanupEditorMarkup();
        this.loadFarConfig();
        this.reopenAddressBookAfterSignIn();
    }
    // Microsoft / Google / Yahoo same-tab sign-in (used only when the popup was blocked) returns here
    // with ?contacts=microsoft|google|yahoo: reopen Select Recipients on that view.
    reopenAddressBookAfterSignIn(){
        const { authorized } = this.store.getState();
        let wanted = null;
        try{ wanted = new URLSearchParams(window.location.search).get("contacts"); }catch(e){ }
        if(wanted !== "microsoft" && wanted !== "google" && wanted !== "yahoo"){ return; }
        this.history.replace(this.history.location.pathname);
        if(authorized){
            this.setState({ addressBookModal: true, addressBookView: wanted });
        }
    }
    componentWillUnmount(){
        if(this.myDocsSource){
            this.myDocsSource.cancel("Request Cancelled");
        }
        window.onbeforeunload = null;
        if(this.farSource){
            this.farSource.cancel("Request Cancelled");
        }
        if(this.state.resetComponent){
            this.store.dispatch({ type: 'UPDATE_STATE', state: {
                customState: null
            }});
        }
    }
    cleanupEditorMarkup(){
        var div = document.querySelector(".DraftEditor-editorContainer > div");
        if(div){
            div.removeAttribute("aria-describedby");
            div.removeAttribute("role");
        }
    }
    getDateString(){
        const date = new Date();
        const dateString = (date.getMonth() + 1)+"_"+date.getDate()+"_"+date.getFullYear()+"_"+date.getHours()+"_"+date.getMinutes()+"_"+date.getSeconds();
        return dateString;
    }
    beforeUnload(){
        try{
            const { response } = this.state;
            const requestData = {
                id: response.hash
            };
            const source = axios.CancelToken.source();
            Api.browserExit(source, requestData).then(data => {
                
            }).catch(err => {
                
            });
        }catch(e){ }
        return "Are you sure you want to cancel this upload?"
    }
    onEmailKeyUp(event) {
        const { user } = this.store.getState();
        if (event && event.nativeEvent.keyCode !== 13 && event.key !== "Tab") {
            return;
        }

        const { emailTo, recipients } = this.state;
        if (emailTo.length <= 0) {
            return;
        }
        if (event && event.key === "Tab") {
            event.preventDefault();
        }

        let commaSeparatedEmails = emailTo.split(/[;,]\s*/).map(e => e.trim()).filter(e => e);
        let newRecipients = [...recipients];
        let remainingEmails = [];
        let limitExceeded = false;

        for (let email of commaSeparatedEmails) {
            const isUnverified = user.hasOwnProperty('is_verified') && !user.is_verified;
            const isOnTrial = user.hasOwnProperty('is_subscription_on_trial') && user.is_subscription_on_trial;

            const tooManyNewRecipients = newRecipients.length >= 5;
            const tooManyDailyRecipients = user.hasOwnProperty('transfer_recipients_in_day') && user.transfer_recipients_in_day > 50;

            if ((isUnverified || isOnTrial) && (tooManyNewRecipients || tooManyDailyRecipients)) {
                limitExceeded = true;
                break;
            }

            // Case-insensitive: A@x.com and a@x.com are the same recipient.
            if (!newRecipients.some(r => String(r).toLowerCase() === email.toLowerCase()) && emailRegex.test(email)) {
                newRecipients.push(email);
            } else {
                remainingEmails.push(email);
            }
        }

        this.setState({
            recipients: newRecipients,
            emailTo: limitExceeded ? "" : (remainingEmails.length > 0 ? remainingEmails.join(", ") : ""),
            sendLimitModal: limitExceeded
        });
    }
    handleChange(event, name) {
        this.setState({
            [name]: event.target.value
        });
    }
    handleDateChange(date, name) {
        try{
            const currentTime = new Date();
            let parsedDate = new Date(date);
            if(parsedDate === "Invalid Date"){
                return;
            }

            if (parsedDate < currentTime) {
                parsedDate = currentTime; 
            }

            this.setState({
                [name]: parsedDate.toISOString()
           });
        }catch(e){ console.log(e); }        
    }
    handleCheckbox(e, name){
        let state = {};
        state[name] = e.target.checked;
        if(name === 'zipUpload'){
            state['zipPasswordToggle'] = false
        }
        this.setState(state);
    }
    handleMessageChange(content, name){
        this.setState({
            [name]: content
        });
    }
    toggleTransfer(event, type){
        this.setState({
            transferType: type
        });
    }
    onFilesSelect(files){
        this.setState({files: files});
        this.updateZipUploadStatus()
    }
    onScroll(e){
        if(e.target && e.target.scrollTop <= 0){
            this.setState({
                showTransfer: false,
                scrollTo: 0
            });
        }
    }
    sendFiles(){
        const isValid = this.validateForm();
        if(!isValid){
            return;
        }

        const { emailTo, linkPassword, zipName, zipUpload, zipPassword, requireVerification } = this.state;
        let { expire } = this.state;

        let recipients = this.state.recipients;
        let commaSeparatedEmails = emailTo.split(/[;,]\s*/);
        if(emailTo.length > 0){
            if(commaSeparatedEmails.length > 1){
                commaSeparatedEmails.map((email) => {
                    if(!recipients.some(r => String(r).toLowerCase() === email.trim().toLowerCase()) && emailRegex.test(email.trim())){
                        recipients.push(email.trim());
                    }
                    return null;
                });
            }else{
                if(!recipients.some(r => String(r).toLowerCase() === emailTo.trim().toLowerCase()) && emailRegex.test(emailTo.trim())){
                    recipients.push(emailTo.trim());
                }
            }
        }

        Cookie.write("sendlinx_your_email", this.state.yourEmail);
        let message = this.state.message.toString("html");
        
        const requestData = {
            recipients: recipients,
            from: this.state.yourEmail,
            message: message,
            transferType: this.state.transferType,
            uploadType: "web"
        };

        if(linkPassword !== ''){
            requestData['linkPassword'] = linkPassword;
        }
        if(expire !== null){
            const parsedDate = new Date(expire);
            const day = parsedDate.getDate();
            const month = parsedDate.getMonth() + 1;
            const year = parsedDate.getFullYear();
            const hours = parsedDate.getHours();
            const mins = parsedDate.getMinutes();
            const secs = parsedDate.getSeconds();
            expire = day+"-"+month+"-"+year+" "+hours+":"+mins+":"+secs;

            requestData['expire'] = expire;
        }
        if(zipUpload === true){
            requestData['zipUpload'] = 1;
            requestData['zipName'] = zipName;
            if(zipPassword !== ''){
                requestData['zipPassword'] = zipPassword
            }
        }
        // Email verification restricts access to the named recipients, so it
        // only applies to email transfers where recipients are collected.
        if(this.state.transferType === "email" && requireVerification === true){
            // recipients are already included in requestData above.
            requestData['requireVerification'] = true;
        }

        // File Attachment Rules: send the client evaluation + sender actions so the
        // backend can re-check every file/recipient pair and write the audit trail.
        const farEvaluation = this.getFarEvaluation(true);
        if(farEvaluation){
            requestData['farEvaluation'] = buildFarSendPayload(farEvaluation, this.state.farActions);
        }

        const source = axios.CancelToken.source();
        this.setState({
            uploading: true,
            recipients: recipients,
            emailTo: "",
            totalFiles: this.getFilesCount(),
            cancelToken: source,
            showError: false,
            showPwnedError: false,
            totalSize: this.getTotalSize(),
        });

        window.onbeforeunload = this.beforeUnload;
        const that = this;
        Api.sendFiles(requestData, this.state.files, source).then(data => {
            that.setState({
                response: data,
            });
            that.uploadFiles(data.files);
        }).catch(err => {
            console.log(err);
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    cancelUpload(){
        if (this.state.cancelToken) {
            this.state.cancelToken.cancel('Request Cancelled')
        }
        
        this.setState({
            uploading: false,
            cancelToken: null,
            totalSent: 0,
            singleSent: 0,
            showError: false,
            errorMessage: ""
        });

        const { response } = this.state;
        if(response === null){
            return;
        }

        const requestData = {
            id: response.id
        }

        Api.cancelFiles(requestData).then(data => {
            //Silent
        }).catch(err => {
            //Silent
        });
    }
    resumeUpload(){
        this.setState({
            singleSent: 0,
        });
        this.partNumber = this.partNumber - 1;
        if(this.partNumber < 0){
            this.partNumber = 0;
        }
        const { response, resumableKey } = this.state;
        const fileData = this.getNextFile(response.files, resumableKey);
        const source = axios.CancelToken.source();
        this.uploadMultiPart(response.files, fileData, resumableKey, source);
        this.partNumber = this.partNumber + 1;
    }
    sendAnother(){
        this.setState({
            success: false,
            myDocsItems: [],
            myDocsPending: false,
            myDocsError: null,
            farExceptions: {},
            farActions: [],
            farChecked: false,
            farModal: null
        });
    }
    getTotalSize(){
        let totalSize = 0;
        this.state.files.map(item => {
            if(item.type === "folder"){
                item.files.map(file => {
                    totalSize += file.size;
                    return null;
                });
            }else{
                totalSize += item.file.size;
                return false;
            }
            return null;
        });
        return totalSize;
    }
    getFilesCount(){
        let totalFiles = 0;
        this.state.files.map(item => {
            if(item.type === "folder"){
                totalFiles += item.files.length;
            }else{
                totalFiles++;
            }
            return null;
        });
        return totalFiles;
    }
    getRemainingSize(){
        let totalSize = 0;
        let maxSize = this.state.maxSize;
        const { authorized, user } = this.store.getState();
        if(authorized){
            maxSize = user.quota - user.usage;
        }
        this.state.files.map(item => {
            if(item.type === "folder"){
                item.files.map(file => {
                    totalSize += file.size;
                    return null;
                });
            }else{
                totalSize += item.file.size;
                return false;
            }
            return null;
        });
        return maxSize - totalSize;
    }
    isMultiPartSupported(file){
        if(file === null){
            return false;
        }
        const chunks = this.getTotalChunks(file);
        if(chunks < 2){
            return false;
        }
        const slice = file.slice || file.mozSlice || file.webkitSlice;
        if(typeof(slice) === "function"){
            return true;
        }
        return false;
    }
    getPartContent(file){
        let { chunkSize } = this.state;
        const slice = file.slice || file.mozSlice || file.webkitSlice;
        let end = this.chunksSent + chunkSize;
        if ((file.size - end) < 0) {
            end = file.size;
        }
        
        const blob = slice.call(file, this.chunksSent, end);
        // this.chunksSent = this.chunksSent + chunkSize;
        return blob;
    }
    getTotalChunks(file){
        const { chunkSize } = this.state;
        var chunks = Math.ceil(file.size/chunkSize,chunkSize);
        return chunks;
    }
    uploadFiles(files, key = 0){
        const fileData = this.getNextFile(files, key);
        const that = this;
        if(fileData === null){
            window.onbeforeunload = null;
            if(this.state.files.length > 0){
                const source = axios.CancelToken.source();
                that.setState({
                    cancelToken: source
                });
                const { zipUpload, zipName, zipPassword } = this.state;
                const requestData = {
                    zipUpload: (zipUpload ? 1 : 0)
                }
                if(zipName !== null){
                    requestData['zipName'] = zipName;
                }
                if(zipPassword !== null){
                    requestData['zipPassword'] = zipPassword;
                }
                Api.processMedia(this.state.response.hash, source, false, requestData).then(data => {
                    if(data.hasOwnProperty("user")){
                        localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
                        let newUser = Api.prepareMemberObject(data.user);
                        this.store.dispatch({ type: 'UPDATE_STATE', state: {
                            user: newUser,
                            customState: {
                                response: this.state.response,
                                success: true,
                                transferType: this.state.transferType,
                                type: "send"
                            }
                        }});
                    }else{
                        this.setState({
                            uploading: false,
                            success: true
                        })
                    }
                }).catch(err => {
                    this.setState({
                        uploading: false,
                        success: true
                    });
                });
            }else{
                this.setState({
                    uploading: false,
                    success: true
                });
            }
            return;
        }

        if(this.isMultiPartSupported(fileData.localFile)){
            try{
                this.partNumber = 0;
                this.chunksSent = 0;
                const source = axios.CancelToken.source();
                this.uploadMultiPart(files, fileData, key, source);
                this.partNumber = this.partNumber + 1;
            }catch(e){
                console.log(e);
            }
        }else{
            const source = axios.CancelToken.source();
            that.setState({
                cancelToken: source,
                showError: false,
                errorMessage: ""
            });
            Api.createMedia(fileData.localFile, fileData.uploadedFile, source, this.onUploadProgress).then(data => {
                that.setState({
                    totalSent: that.state.totalSent + fileData.localFile.size,
                    singleSent: 0,
                });
                that.uploadFiles(files, ++key);
            }).catch(err => {
                if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                    this.setState({
                        showError: true,
                        errorMessage: err.message
                    });
                }
            });
        }
    }
    uploadMultiPart(files, fileData, key, source){
        const blob = this.getPartContent(fileData.localFile);
        const requestData = {
            partNumber: (this.partNumber + 1),
            chunkSize: blob.size,
            id: fileData.uploadedFile.id
        };
        this.setState({
            cancelToken: source,
            showError: false,
            errorMessage: "",
            resumableKey: key,
            resumable: false,
            uploading: true
        });
        
        const that = this;
        var chunks = this.getTotalChunks(fileData.localFile);
        const { chunkSize } = this.state;
        Api.getPartUrl(fileData.localFile, blob, requestData, source, this.onUploadProgress).then(data => {
            this.chunksSent = this.chunksSent + chunkSize;
            if(this.partNumber < chunks){
                source = axios.CancelToken.source();
                that.setState({
                    totalSent: that.state.totalSent + blob.size,
                    singleSent: 0,
                    cancelToken: source,
                    showError: false,
                    errorMessage: ""
                });
                this.uploadMultiPart(files, fileData, key, source);
                this.partNumber = this.partNumber + 1;
            }else{
                const source = axios.CancelToken.source();
                that.setState({
                    totalSent: that.state.totalSent + blob.size,
                    singleSent: 0,
                    cancelToken: source,
                    showError: false,
                    errorMessage: ""
                });
                that.finalizeMultiPart(files, fileData, key, source);
            }
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                let state = {
                    showError: true,
                    errorMessage: err.message
                };
                if(err.message === "Network Error"){
                    state['resumable'] = true;
                }
                this.setState(state);
            }
        });
    }
    finalizeMultiPart(files, fileData, key, source){
        const requestData = {
            chunks: this.getTotalChunks(fileData.localFile),
            id: fileData.uploadedFile.id
        };
        Api.finalizeMultiPart(requestData, source).then(data => {
            this.uploadFiles(files, ++key);
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    showError: true,
                    errorMessage: err.message
                });
            }
        });
    }
    getNextFile(files, key){
        if(!files.hasOwnProperty(key)){
            return null;
        }

        const uploadedFile = files[key];
        let localFile = null;

        this.state.files.map(item => {
            if(item.type === "folder"){
                item.files.map(file => {
                    if(file.webkitRelativePath === uploadedFile.path+"/"+uploadedFile.name){
                        localFile = file;
                        return false;
                    }
                    return null;
                });
            }else if(item.file.name === uploadedFile.name){
                localFile = item.file;
                return false;
            }
            return null;
        });
        const fileObject = {
            localFile: localFile,
            uploadedFile: uploadedFile
        }
        return fileObject;
    }
    onFileDelete(key){
        let filesArray = this.state.files;
        filesArray.splice(key, 1);
        this.onFilesSelect(filesArray);
        this.setState({
            files: filesArray
        });
        this.updateZipUploadStatus()
    }
    validateForm(yourEmailValidation = true){
        let validation = {
            emailTo: 'success',
            isValid: true
        };

        if(this.state.transferType === "email"){
            if((this.state.emailTo.length <= 0 || !emailRegex.test(this.state.emailTo)) && this.state.recipients.length <= 0){
                validation.emailTo = "error";
                validation.isValid = false;
            }
        }
        if(yourEmailValidation){
            validation['yourEmail'] = 'success';

            if(this.state.yourEmail.length <= 0 || !emailRegex.test(this.state.yourEmail)){
                validation.yourEmail = "error";
                validation.isValid = false;
            }
        }
        this.setState({validation: validation});
        return validation.isValid;
    }
    removeRecipient(e, email){
        e.preventDefault();
        let recipients = this.state.recipients;
        if(recipients.length <= 0 || email.length <= 0){
            return;
        }
        const index = recipients.indexOf(email);
        recipients.splice(index, 1);
        this.setState({recipients: recipients});
    }
    editRecipient(e, email){
        e.preventDefault();
        this.onEmailKeyUp();
        let recipients = this.state.recipients;
        if(recipients.length <= 0 || email.length <= 0){
            return;
        }
        const index = recipients.indexOf(email);
        recipients.splice(index, 1);
        this.setState({
            recipients: recipients,
            emailTo: email
        });
    }
    getDownloadLink(){
        const { response } = this.state;
        const location = window.location;
        let downloadLink = location.protocol+"//"+location.host+"/downloads";
        if(response !== null){
            downloadLink += "/"+response.hash;
        }
        return downloadLink;
    }
    onUploadProgress(e){
        this.setState({
            singleSent: e.loaded
        });
    }
    copyDownloadLink(){
        const link = this.getDownloadLink();
        helper.copyTextToClipboard(link);
        this.setState({snackbarOpen: true});
    }
    closeSnackbar(){
        this.setState({snackbarOpen: false});
    }
    renderFile(item, key){
        let  folderSize = 0;
        if(item.type === "folder"){
            item.files.map(file => {
                return folderSize += file.size;
            });
        }
        if(item.type === "file"){
            return <li key={key}>
                <div className="file">
                    <div className="file-header">
                        <div className="file-title">
                            <span className="file-icon icon"><img src={fileicon} alt={"file"} /></span>
                            <span className="file-name">{item.file.name}</span>
                            <span className="file-detail">{helper.getFormatedSize(item.file.size)}</span>
                        </div>
                        <div className="file-actions">
                            <div className="filelist-action filelist-action-delete">
                                <svg  onClick={() => this.onFileDelete(key)} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 2560 1920">
                                    <path d="M754 1868c-28-29-209-234-403-456L0 1010v-48c0-41 5-55 37-93C135 754 769 33 787 17c19-16 65-17 789-15 767 3 769 3 810 25 51 27 120 96 147 147l22 41v1490l-22 41c-27 51-96 120-147 147-41 22-43 22-811 25l-770 2-51-52zm1531-180c56-25 55-11 55-727 0-490-3-667-12-686-25-56-9-55-745-55H905L585 585C409 786 265 955 265 960s144 174 320 375l320 365h677c504 0 684-3 703-12z"/>
                                    <path d="M1204 1356c-28-28-34-41-34-77 0-41 4-46 137-181l137-138-137-138c-133-135-137-140-137-181 0-36 6-49 34-77s41-34 77-34c41 0 46 4 181 137l138 137 138-137c135-133 140-137 181-137 36 0 49 6 77 34s34 41 34 77c0 41-4 46-137 181l-137 138 137 138c133 135 137 140 137 181 0 36-6 49-34 77s-41 34-77 34c-41 0-46-4-181-137l-138-137-138 137c-135 133-140 137-181 137-36 0-49-6-77-34z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </li>;
        }
        return <li key={key}>
            <div className="file">
                <div className="file-header">
                    <div className="file-title">
                        <span className="folder-icon icon">
                            <img src={foldericon} alt={"folder"} />
                        </span>
                        <span className="file-name">{item.name} ({item.files.length} items)</span>
                        <span className="file-detail">{helper.getFormatedSize(folderSize)}</span>
                    </div>
                    <div className="fileactions">
                        <div className="filelist-action filelist-action-delete">
                            <svg  onClick={() => this.onFileDelete(key)} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 2560 1920">
                                <path d="M754 1868c-28-29-209-234-403-456L0 1010v-48c0-41 5-55 37-93C135 754 769 33 787 17c19-16 65-17 789-15 767 3 769 3 810 25 51 27 120 96 147 147l22 41v1490l-22 41c-27 51-96 120-147 147-41 22-43 22-811 25l-770 2-51-52zm1531-180c56-25 55-11 55-727 0-490-3-667-12-686-25-56-9-55-745-55H905L585 585C409 786 265 955 265 960s144 174 320 375l320 365h677c504 0 684-3 703-12z"/>
                                <path d="M1204 1356c-28-28-34-41-34-77 0-41 4-46 137-181l137-138-137-138c-133-135-137-140-137-181 0-36 6-49 34-77s41-34 77-34c41 0 46 4 181 137l138 137 138-137c135-133 140-137 181-137 36 0 49 6 77 34s34 41 34 77c0 41-4 46-137 181l-137 138 137 138c133 135 137 140 137 181 0 36-6 49-34 77s-41 34-77 34c-41 0-46-4-181-137l-138-137-138 137c-135 133-140 137-181 137-36 0-49-6-77-34z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </li>;
    }
    getConfig(){
        const toolbarConfig = {
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', /*'BLOCK_TYPE_DROPDOWN',*/ 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
              {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
              {label: 'Italic', style: 'ITALIC'},
              {label: 'Underline', style: 'UNDERLINE'}
            ],
            // BLOCK_TYPE_DROPDOWN: [
            //   {label: 'Normal', style: 'unstyled'},
            //   {label: 'Heading Large', style: 'header-one'},
            //   {label: 'Heading Medium', style: 'header-two'},
            //   {label: 'Heading Small', style: 'header-three'}
            // ],
            BLOCK_TYPE_BUTTONS: [
              {label: 'UL', style: 'unordered-list-item'},
              {label: 'OL', style: 'ordered-list-item'}
            ]
        };
        return toolbarConfig;
    }
    getCustomControls(){
        const { classes } = this.props;
        const { message } = this.state;
        let controls = [];
        controls.push(
            <div className="ButtonGroup__root___3lEAn" key={1}>
                <span className="Dropdown__root___3ALmx">
                    <label className={classes.hiddenLabel} htmlFor="heading_type1">Heading</label>
                    <select id="heading_type1" onChange={(e) => {
                        const newValue = message.setEditorState(RichUtils.toggleBlockType(message.getEditorState(), e.target.value));
                        this.handleMessageChange(newValue, "message");
                    }}>
                        <option value="unstyled">Normal</option>
                        <option value="header-one">Heading Large</option>
                        <option value="header-two">Heading Medium</option>
                        <option value="header-three">Heading Small</option>
                    </select>
                    <span className="Dropdown__value___34Py9"> </span>
                </span>
            </div>
        );
        return controls;
    }
    handlePasswordToggle(){
        this.setState({
            zipPasswordToggle: !this.state.zipPasswordToggle
        })
    }
    hasFolder(files){
        let hasFolder = false;
        files.map(item => {
            if(item.type === "folder"){
                hasFolder = true;
            }
            return null;
        });
        return hasFolder;
    }
    updateZipUploadStatus(){
        const { files, showZipConfirmationModal } = this.state;
        let sizeInMb = this.getTotalSize()/ 1024 / 1024;
        let hasFolder = this.hasFolder(files);
        if((files.length > 5 && sizeInMb > 100) || hasFolder){
            this.setState({
                zipUpload: true,
                showZipUploadCheckbox: true,
                zipCheckboxDisabledStatus: true,
                showZipConfirmationModal: true
            })
        }else if((files.length > 5 && sizeInMb < 100) || (files.length > 1 && files.length <= 5 && sizeInMb > 100)){
            let state = {};
            state['showZipUploadCheckbox'] = true;
            state['zipUpload'] = this.state.zipUpload;
            state['zipCheckboxDisabledStatus'] = false;
            if(showZipConfirmationModal === true){
                state['zipConfirmationModal'] = true;
                state['showZipConfirmationModal'] = false;
            }
            if(files.length > 5 && sizeInMb < 100){
                state['zipConfirmationMessage'] = "Since you got more than 5 files, do you wish to zip the file?";
            }else{
                state['zipConfirmationMessage'] = "Since you got few files over a 100 mb, do you wish to zip the file?";
            }

            this.setState(state);
        }else if((files.length > 1 && files.length <= 5 && sizeInMb < 100)){
            this.setState({
                showZipUploadCheckbox: true,
                zipUpload: this.state.zipUpload,
                zipCheckboxDisabledStatus: false,
                showZipConfirmationModal: true
            })
        }else{
            this.setState({
                zipUpload: false,
                showZipUploadCheckbox: false,
                zipCheckboxDisabledStatus: false,
                zipPasswordToggle: false,
                zipPassword: '',
                showZipConfirmationModal: true,
                zipConfirmationModal: false,
                zipConfirmationMessage: "",
            })
        }
    }
    onZipModalSuccess(status = false){
        let state = {};
        state['showZipConfirmationModal'] = false;
        state['zipConfirmationModal'] = false;
        state['zipConfirmationMessage'] = "";
        if(status === true){
            state['zipUpload'] = true;
            state['showZipUploadCheckbox'] = true
        }else{
            state['zipUpload'] = false;
        }

        this.setState(state);
    }
    onUpgradeModal(status = true){
        this.setState({
            upgradeModal: status
        });
    }
    onUpgradeModalSuccess(){
        this.history.push("/user/plans");
    }
    renderConfirmationModal(open = true){
        return (
            <ConfirmationModal 
                open={open} 
                onClose={() => this.onUpgradeModal(false)} 
                onSuccess={() => this.onUpgradeModalSuccess()}
                confirmationMessage="Please upgrade to paid plan in order to use this feature."
                cancelButtonText={"Cancel"}
                successButtonText={"Upgrade Now"}
            />
        )
    }
    onViewPassword(name){
        this.setState({
            [name]: !this.state[name]
        })
    }
    onClearDate(){
        this.setState({
            expire: null
        })
    }
    haveBeenPwned(){
        const isValid = this.validateForm(false);
        if(!isValid){
            return;
        }

        const source = axios.CancelToken.source();
        
        const { emailTo } = this.state;

        let recipients = this.state.recipients;
        let commaSeparatedEmails = emailTo.split(/[;,]\s*/);
        if(emailTo.length > 0){
            if(commaSeparatedEmails.length > 1){
                commaSeparatedEmails.map((email) => {
                    if(!recipients.includes(email.trim()) && emailRegex.test(email.trim())){
                        recipients.push(email.trim());
                    }
                    return null;
                });
            }else{
                if(!recipients.includes(emailTo.trim()) && emailRegex.test(emailTo.trim())){
                    recipients.push(emailTo.trim());
                }
            }
        }

        this.setState({
            pwnedSuccessMessage: '',
            checkingpwned: true,
            emailTo: "",
            cancelToken: source,
            showError: false,
            showPwnedError: false,
            foundPwned: false,
        })

        let requestData = {
            recipients: recipients,
        };

        Api.haveBeenPwned(requestData, source).then(data => {
            const breachedEmails = Object.entries(data.results)
                .filter(
                    ([email, info]) => 
                    typeof info === 'object' && 
                    info !== null && 
                    !info.error_message && 
                    info.breached === true
                )
                .map(([email]) => email);
                
            let stateObj = {
                checkingpwned: false,
                foundPwned: data.found_breach,
                pwnedSuccessMessage: "None of the email address(es) listed below appear in any known data breaches. You're good to go, but we still recommend using passwords to protect any sensitive files you send.",
                errorMessage: "The email address(es) in red have been linked to a known data breach. To help protect your information, we recommend securing any sensitive files you send with a password.",
                breachedEmails: breachedEmails
            };

            this.setState(stateObj);
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message") && err.message !== 'Request Cancelled'){
                this.setState({
                    pwnedSuccessMessage: '',
                    checkingpwned: false,
                    showPwnedError: true,
                    errorMessage: err.message,
                    foundPwned: false
                });
            }
        });
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<GridItem key={key} className={"passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </GridItem>);
                key++;
            }
            return errorMessages;
        }
        return <GridItem className={"passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </GridItem>;
    }
    /* ------------------------------------------------------------------ */
    /* File Attachment Rules (FAR)                                         */
    /* ------------------------------------------------------------------ */
    loadFarConfig(){
        const { authorized, user } = this.store.getState();
        if(!authorized || !isFarEnabled(user)){
            return;
        }
        if(this.farSource){
            this.farSource.cancel("Request Cancelled");
        }
        const source = axios.CancelToken.source();
        this.farSource = source;
        this.setState({ far: Object.assign({}, this.state.far, { active: true, loading: true, error: null }) });
        FarApi.getConfig(source).then(config => {
            const settings = config.settings;
            const adminOnly = settings.enforcement === FAR_ENFORCEMENT.BLOCK || settings.override_permission === "admins";
            this.setState({
                far: {
                    active: !!config.enabled,
                    loading: false,
                    error: null,
                    settings: settings,
                    rules: config.rules,
                    canOverride: !!config.canOverride && (adminOnly ? isFarAdmin(user) : true),
                    // Administrator authorization for "admin_approval" recipient exclusions (server decides; this drives the UI).
                    isAdmin: config.isAdmin !== undefined ? !!config.isAdmin : isFarAdmin(user)
                }
            });
        }).catch(err => {
            if(err && err.message === "Request Cancelled"){
                return;
            }
            // The server re-checks every transfer, so a failed load warns but does not block sending.
            this.setState({
                far: Object.assign({}, this.state.far, { active: true, loading: false, error: "File Attachment Rules could not be loaded." })
            });
        });
    }
    getFarRecipients(){
        const { recipients, emailTo } = this.state;
        const list = recipients.slice();
        String(emailTo || "").split(/[;,]\s*/).map(e => e.trim()).filter(e => emailRegex.test(e)).forEach(email => {
            if(!list.some(r => String(r).toLowerCase() === email.toLowerCase())){
                list.push(email);
            }
        });
        return list;
    }
    isFarDeferred(){
        const { far, farChecked } = this.state;
        return far.active && far.settings.real_time === false && !farChecked;
    }
    getFarEvaluation(force = false){
        const { far, transferType, farExceptions } = this.state;
        if(!far.active || far.loading || far.error){
            return null;
        }
        if(!force && this.isFarDeferred()){
            return null;
        }
        return evaluateSend({
            items: this.getActiveItems(),
            recipients: transferType === "email" ? this.getFarRecipients() : [],
            rules: far.rules,
            settings: far.settings,
            transferType: transferType,
            exceptions: farExceptions,
            isAdmin: !!far.isAdmin,
            canOverride: !!far.canOverride
        });
    }
    onSendClick(){
        const { authorized, user } = this.store.getState();
        if(authorized && user.account_type === 5){
            this.onUpgradeModal();
            return;
        }
        const evaluation = this.getFarEvaluation(true);
        if(evaluation){
            if(evaluation.blocksSend){
                this.setState({ farChecked: true, farModal: "resolve" });
                return;
            }
            if(evaluation.requiresAcknowledgement){
                this.setState({ farChecked: true, farModal: "acknowledge" });
                return;
            }
        }
        this.dispatchSend();
    }
    dispatchSend(){
        if(this.isMyDocsSource()){
            this.sendMyDocs();
            return;
        }
        this.sendFiles();
    }
    /* ------------------------------------------------------------------ */
    /* Files source: Upload Files / Select a Folder / My Docs              */
    /* ------------------------------------------------------------------ */
    isMyDocsSource(){
        return this.state.sourceTab === "mydocs";
    }
    getActiveItems(){
        return this.isMyDocsSource() ? this.state.myDocsItems : this.state.files;
    }
    getMyDocsCount(){
        return this.state.myDocsItems.reduce((sum, item) => sum + (item.fileCount || 0), 0);
    }
    getMyDocsSize(){
        return this.state.myDocsItems.reduce((sum, item) => sum + (item.size || 0), 0);
    }
    onSourceSelect(tab){
        const { authorized } = this.store.getState();
        if(tab === "mydocs" && !authorized){
            return;
        }
        // Open the browser's file dialog inside the click handler (needs the user gesture).
        const uploader = this.uploaderRef.current;
        if(tab === "files" && uploader && uploader.onFocus){
            uploader.onFocus();
        }else if(tab === "folder" && uploader && uploader.onDirectoryFocus){
            uploader.onDirectoryFocus();
        }
        const state = { sourceTab: tab, farChecked: false };
        if(tab === "mydocs" && this.state.myDocsItems.length <= 0){
            state.myDocsPicker = true;
        }
        this.setState(state);
    }
    /** Picker result = the full selection. Already-resolved items are reused; new ones are expanded on the server. */
    onMyDocsPicked(rows){
        const known = {};
        this.state.myDocsItems.forEach(item => { known[item.id] = item; });
        const missing = rows.filter(row => !known[row.id]).map(row => row.id);
        const finish = (resolved, error = null) => {
            resolved.forEach(item => { known[item.id] = Object.assign({}, item, { source: "mydocs" }); });
            const items = dedupeMyDocsItems(rows.map(row => known[row.id]).filter(Boolean));
            this.setState({ myDocsItems: items, myDocsResolving: false, myDocsError: error, farChecked: false });
        };
        this.setState({ myDocsPicker: false, myDocsError: null });
        if(missing.length <= 0){
            finish([]);
            return;
        }
        if(this.myDocsSource){
            this.myDocsSource.cancel("Request Cancelled");
        }
        const source = axios.CancelToken.source();
        this.myDocsSource = source;
        this.setState({ myDocsResolving: true });
        MyDocsApi.resolve(missing, source).then(body => {
            const resolved = (body && body.items) || [];
            const error = resolved.length < missing.length ? "Some items could not be added because they are no longer in your My Docs." : null;
            finish(resolved, error);
        }).catch(err => {
            if(err && err.message === "Request Cancelled"){
                return;
            }
            this.setState({ myDocsResolving: false, myDocsError: (err && err.message) || "The selected My Docs files could not be loaded. Please try again." });
        });
    }
    onMyDocsRemove(key){
        const items = this.state.myDocsItems.filter((item, index) => index !== key);
        this.setState({ myDocsItems: items, farChecked: false });
    }
    /**
     * Shares the picked My Docs files as a secure link (emailed to the recipients for
     * email transfers) without uploading them again. The server re-checks File
     * Attachment Rules against each file's real My Docs folder before creating the link.
     */
    sendMyDocs(){
        const isValid = this.validateForm();
        if(!isValid){
            return;
        }
        const { myDocsItems, linkPassword, expire, requireVerification, transferType } = this.state;
        if(myDocsItems.length <= 0){
            return;
        }
        const recipients = transferType === "email" ? this.getFarRecipients() : [];
        const requestData = {
            files: myDocsItems.map(item => item.id),
            // Deepest folder holding every pick: multi-file links are zipped relative to it.
            path: commonFolder(myDocsItems),
            transferType: transferType,
            uploadType: "my_docs",
            message: this.state.message.toString("html"),
            zipUpload: 1
        };
        if(transferType === "email"){
            requestData['recipients'] = recipients;
            // Email the secure link to these external recipients (not an internal user-to-user share).
            requestData['emailLink'] = true;
            if(requireVerification === true){
                requestData['requireVerification'] = true;
            }
        }
        if(linkPassword !== ''){
            requestData['linkPassword'] = linkPassword;
        }
        if(expire !== null){
            // ISO 8601 in UTC; the server stores it in the sender's timezone.
            requestData['expire'] = expire;
        }
        const farEvaluation = this.getFarEvaluation(true);
        if(farEvaluation){
            requestData['farEvaluation'] = buildFarSendPayload(farEvaluation, this.state.farActions);
        }

        const source = axios.CancelToken.source();
        this.myDocsSource = source;
        const state = {
            uploading: true,
            emailTo: "",
            totalFiles: this.getMyDocsCount(),
            totalSize: 0,
            totalSent: 0,
            singleSent: 0,
            showError: false,
            errorMessage: "",
            response: null
        };
        if(transferType === "email"){
            state.recipients = recipients;
        }
        this.setState(state);
        MyDocsApi.share(requestData, source).then(data => {
            this.setState({
                uploading: false,
                success: true,
                response: { hash: data && data.hash ? data.hash : "", id: data && data.id ? data.id : null },
                myDocsPending: !!(data && data.status === "uploaded")
            });
        }).catch(err => {
            if(err && err.message === "Request Cancelled"){
                return;
            }
            this.setState({ showError: true, errorMessage: shareErrorText(err) });
        });
    }
    /** Leaves the progress screen after a failed My Docs share, keeping the form as it was. */
    backToForm(){
        this.setState({ uploading: false, showError: false, errorMessage: "" });
    }
    onAddressBook(status = false){
        if(status){
            // Commit anything typed but not yet turned into a chip, so it isn't lost.
            this.onEmailKeyUp(null);
        }
        this.setState({ addressBookModal: status, addressBookView: "contacts" });
    }
    // Merges Address Book picks into the single Recipients list (case-insensitive, no duplicates).
    // FAR is evaluated from state on render, so new recipients are checked like typed ones.
    onAddressBookAdd(emails){
        const recipients = this.state.recipients.slice();
        const existing = recipients.map(r => String(r).toLowerCase());
        (emails || []).forEach(email => {
            const value = String(email || "").trim().toLowerCase();
            if(value && emailRegex.test(value) && !existing.includes(value)){
                existing.push(value);
                recipients.push(value);
            }
        });
        const validation = Object.assign({}, this.state.validation);
        if(recipients.length > 0 && validation.emailTo === "error"){
            validation.emailTo = "success";
        }
        this.setState({ recipients, validation, addressBookModal: false, farChecked: false });
    }
    onFarRemoveRecipients(toRemove){
        const evaluation = this.getFarEvaluation(true);
        const remove = toRemove.map(r => String(r).toLowerCase());
        const now = new Date().toISOString();
        const actions = this.state.farActions.slice();
        if(evaluation){
            evaluation.unresolvedPairs.filter(p => remove.includes(p.recipient)).forEach(p => {
                actions.push({ action: "recipient_removed", recipient: p.recipient, file: p.fileName, ruleId: p.ruleId, at: now });
            });
        }
        const recipients = this.state.recipients.filter(r => !remove.includes(String(r).toLowerCase()));
        const emailTo = String(this.state.emailTo || "").split(/[;,]\s*/).filter(e => !remove.includes(e.trim().toLowerCase())).join(", ");
        this.setState({ recipients, emailTo, farActions: actions });
    }
    onFarResolve({ action, reason }){
        const evaluation = this.getFarEvaluation(true);
        if(!evaluation){
            this.setState({ farModal: null });
            return;
        }
        const { user } = this.store.getState();
        const now = new Date().toISOString();
        const exceptions = Object.assign({}, this.state.farExceptions);
        const actions = this.state.farActions.slice();
        const auditAction = action === "authorized" ? "exception_authorized" : "ignored";
        // Only pairs this sender may override (hard-block exclusions never; admin approval only for administrators).
        evaluation.unresolvedPairs.filter(pair => pair.overridable).forEach(pair => {
            exceptions[pair.key] = { action: action, reason: reason, at: now, by: user ? user.email : "" };
            actions.push({ action: auditAction, recipient: pair.recipient, file: pair.fileName, ruleId: pair.ruleId, reason: reason, at: now });
        });
        const sendNow = this.state.farModal === "acknowledge";
        this.setState({ farExceptions: exceptions, farActions: actions, farModal: null }, () => {
            // Warn-only mode: acknowledging is the Send action. Otherwise return to the Send page.
            if(sendNow){
                this.dispatchSend();
            }
        });
    }
    onDragOver(e){
        e.preventDefault();
        if(!this.state.dragOver){
            this.setState({ dragOver: true });
        }
    }
    onDragLeave(e){
        if(e.currentTarget.contains(e.relatedTarget)){
            return;
        }
        this.setState({ dragOver: false });
    }
    onDrop(e){
        e.preventDefault();
        if(this.isMyDocsSource()){
            // Files dropped from the computer are uploads.
            this.setState({ sourceTab: "files" });
        }
        const dropped = e.dataTransfer ? e.dataTransfer.files : null;
        const items = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : null;
        if(!dropped || dropped.length <= 0){
            this.setState({ dragOver: false });
            return;
        }
        const disallowed = Config.getDisallowedExtensions();
        // Mutate the shared array in place: CustomFileUpload keeps the same reference.
        const files = this.state.files;
        for(let i = 0; i < dropped.length; i++){
            const file = dropped[i];
            const entry = items && items[i] && items[i].webkitGetAsEntry ? items[i].webkitGetAsEntry() : null;
            if(entry && entry.isDirectory){
                continue; // Folders are added with "Select a folder".
            }
            const extension = file.name.split(".").pop();
            if(disallowed && disallowed.length > 0 && disallowed.includes(extension)){
                continue;
            }
            const exists = files.some(item => item.type === "file" && item.file.name === file.name);
            if(!exists){
                files.push({ type: "file", file: file });
            }
        }
        this.setState({ dragOver: false });
        this.onFilesSelect(files);
    }
    setExpiryPreset(days){
        const date = new Date();
        date.setDate(date.getDate() + days);
        this.handleDateChange(date, "expire");
        this.setState({ expirePreset: days });
    }
    getSendDisabledReason(farEvaluation){
        const { files } = this.state;
        const { authorized, user } = this.store.getState();
        if(this.isMyDocsSource()){
            if(this.state.myDocsResolving){
                return "Checking the selected My Docs files…";
            }
            if(this.state.myDocsItems.length <= 0){
                return "Select at least one file from My Docs.";
            }
            if(this.getMyDocsCount() <= 0){
                return "The selected folders are empty.";
            }
            if(farEvaluation && farEvaluation.blocksSend){
                return this.getFarBlockedReason(farEvaluation);
            }
            return null;
        }
        const totalSize = this.getTotalSize();
        if(files.length <= 0){
            return "Add at least one file to send.";
        }
        if(authorized && (user.quota - user.usage) < totalSize){
            return "Your upload is larger than your remaining storage.";
        }
        if(!authorized && this.state.maxSize < totalSize){
            return "Your upload is larger than the allowed limit.";
        }
        if(totalSize > this.state.maxFileUploadSize){
            return "A file is larger than the per-file limit.";
        }
        if(farEvaluation && farEvaluation.blocksSend){
            return this.getFarBlockedReason(farEvaluation);
        }
        return null;
    }
    getFarBlockedReason(farEvaluation){
        if(farEvaluation.hasExclusions){
            const names = Object.keys(farEvaluation.excludedRecipients);
            return "Blocked by FAR exclusion: "+names.join(", ")+(farEvaluation.canResolveAll ? ". Review the recipients before sending." : ". Remove "+(names.length === 1 ? "this recipient" : "these recipients")+" to send.");
        }
        return "Resolve the File Attachment Rules warning before sending.";
    }
    getRecipientFarStatus(email, farEvaluation){
        if(!farEvaluation || farEvaluation.matchedFiles.length <= 0){
            return null;
        }
        const target = String(email).toLowerCase();
        if(farEvaluation.excludedRecipients && farEvaluation.excludedRecipients[target]){
            return "blocked";
        }
        if(farEvaluation.unauthorizedRecipients.includes(target)){
            return "bad";
        }
        if(farEvaluation.overriddenPairs.some(p => p.recipient === target)){
            return "warn";
        }
        if(farEvaluation.authorizedRecipients.includes(target)){
            return "ok";
        }
        return null;
    }
    renderSendFile(item, key, farItem){
        const { classes } = this.props;
        const { far } = this.state;
        const isFolder = item.type === "folder";
        const name = isFolder ? item.name : item.file.name;
        let size = 0;
        if(isFolder){
            item.files.forEach(file => { size += file.size; });
        }else{
            size = item.file.size;
        }
        const statusId = "far-file-status-"+key;
        return (
            <li className={classes.spFile} key={(isFolder ? "folder-" : "file-")+name}>
                <div className={classes.spFileRow}>
                    <img className={classes.spFileIcon} src={isFolder ? foldericon : fileicon} alt="" aria-hidden="true" />
                    <div className={classes.spFileText}>
                        <p className={classes.spFileName} title={name}>{name}</p>
                        <p className={classes.spFileMeta}>{isFolder ? item.files.length+" items · " : ""}{helper.getFormatedSize(size)}</p>
                    </div>
                    <button type="button" className={classes.spIconButton} aria-label={"Remove "+name} title="Remove" onClick={() => this.onFileDelete(key)}>
                        <CloseIcon />
                    </button>
                </div>
                {
                    farItem ?
                        <FarFileStatus item={farItem} settings={far.settings} id={statusId} />
                    : null
                }
            </li>
        );
    }
    renderMyDocsItem(item, key, farItem){
        const { classes } = this.props;
        const { far } = this.state;
        const isFolder = item.type === "folder";
        const statusId = "far-mydocs-status-"+key;
        const meta = [
            "In "+parentFolder(item.path),
            isFolder ? (item.fileCount || 0)+" file"+(item.fileCount === 1 ? "" : "s") : null,
            helper.getFormatedSize(item.size || 0)
        ].filter(Boolean).join(" · ");
        return (
            <li className={classes.spFile} key={"mydocs-"+item.id}>
                <div className={classes.spFileRow}>
                    <img className={classes.spFileIcon} src={isFolder ? foldericon : fileicon} alt="" aria-hidden="true" />
                    <div className={classes.spFileText}>
                        <p className={classes.spFileName} title={item.path}>{item.name}</p>
                        <p className={classes.spFileMeta}>{meta}</p>
                        { item.truncated ? <p className={classes.spFileMeta}>Large folder: the first 10,000 files are checked here. The server checks every file when you send.</p> : null }
                    </div>
                    <button type="button" className={classes.spIconButton} aria-label={"Remove "+item.name} title="Remove" onClick={() => this.onMyDocsRemove(key)}>
                        <CloseIcon />
                    </button>
                </div>
                {
                    farItem ?
                        <FarFileStatus item={farItem} settings={far.settings} id={statusId} />
                    : null
                }
            </li>
        );
    }
    renderTransferSummary(){
        const { classes } = this.props;
        const { transferType, linkPassword, expire, requireVerification } = this.state;
        const recipients = this.getFarRecipients();
        const isMyDocs = this.isMyDocsSource();
        return (
            <section className={classes.spCard} aria-labelledby="sp-summary-title">
                <h2 className={classes.spCardTitle} id="sp-summary-title"><SecurityIcon aria-hidden="true" />Transfer summary</h2>
                <ul className={classes.spSummaryList}>
                    { transferType === "email" ? <li className={classes.spSummaryItem}><span>Recipients</span><span>{recipients.length}</span></li> : <li className={classes.spSummaryItem}><span>Type</span><span>Share link</span></li> }
                    <li className={classes.spSummaryItem}><span>Source</span><span>{isMyDocs ? "My Docs (no upload)" : "Upload from computer"}</span></li>
                    <li className={classes.spSummaryItem}><span>Files</span><span>{ isMyDocs ? this.getMyDocsCount()+" · "+helper.getFormatedSize(this.getMyDocsSize()) : this.getFilesCount()+" · "+helper.getFormatedSize(this.getTotalSize()) }</span></li>
                    <li className={classes.spSummaryItem}><span>Link password</span><span>{linkPassword ? "Set" : "Not set"}</span></li>
                    <li className={classes.spSummaryItem}><span>Expiry</span><span>{expire ? new Date(expire).toLocaleDateString() : "No expiry"}</span></li>
                    { transferType === "email" ? <li className={classes.spSummaryItem}><span>Email verification</span><span>{requireVerification ? "Required" : "Off"}</span></li> : null }
                </ul>
            </section>
        );
    }
    render() {
        const { files, transferType, validation, recipients, uploading, totalSize, totalSent, success,
            response, singleSent, totalFiles, message, showError, showPwnedError, resumable, linkPassword, expire,
            zipUpload, zipPassword, zipPasswordToggle, showZipUploadCheckbox, zipCheckboxDisabledStatus, zipConfirmationModal,
            zipConfirmationMessage, upgradeModal, yourEmail, emailTo, maxSize, viewPassword, viewZipPassword, 
            maxFileUploadSize, checkingpwned, pwnedSuccessMessage, foundPwned, breachedEmails, sendLimitModal, requireVerification } = this.state;
        const { classes, slider } = this.props;
        const { authorized, user } = this.store.getState();
        const totalUploaded = totalSent + singleSent;

        let progress = 0;
        let progressOffset = 502.655;
        if(totalSize > 0){
            progress = (totalUploaded/totalSize)*100;
            if(progress > 0){
                progressOffset = ((100 - progress)/100)*progressOffset;
            }
        }
        const roundedValue = Math.round(progress);
        const filesCount = this.getFilesCount();
        const remainingSize = this.getRemainingSize();
        const emailError = ((validation.emailTo === "error") || (emailTo.length > 0 && !emailRegex.test(emailTo)));
        const emailSuccess = ((validation.emailTo === "success") || (emailTo.length > 0 && emailRegex.test(emailTo)));
        if(success){
            return (
                <div className={classes.landingPageContainer}>
                    <div className={classes.transferForm+" transferFormSuccess "+classes.uploaderComplete}>
                        <div className={classes.uploaderCompleteContent}>
                            <div className="success-image">
                                <img src={successGif} alt="success"></img>
                            </div>
                            <h2>You’re done!</h2>
                            {
                                this.isMyDocsSource() ?
                                    <>
                                        <p>
                                            { transferType === "email" ? "Your secure link has been emailed to "+recipients.length+" recipient"+(recipients.length === 1 ? "" : "s")+"." : "Your secure link is ready." }
                                            { " " }
                                            { expire ? "It's available until "+new Date(expire).toLocaleString()+"." : "It has no expiry date." }
                                            { " You can manage it in " }<RouterLink to="/user/links">Link Manager</RouterLink>.
                                        </p>
                                        { this.state.myDocsPending ? <p>Sendlinx is preparing a zip for this large selection. The link will work in a few minutes.</p> : null }
                                    </>
                                : transferType === "email" ? 
                                    <p>The download email has been sent – your transfer is available for 7 days.</p>
                                :
                                    <p>Your transfer is available for 7 days.</p>
                            }
                            <div className={classes.downloadLink}>
                                <RouterLink to={"/downloads"+(response !== null ? "/"+response.hash : "")} className={classes.dropdownLink}>
                                    {this.getDownloadLink()}
                                </RouterLink>
                            </div>
                            <RouterLink to={"/success"} className={classes.dropdownLink} style={{display: "none"}}>
                                <Button color="transparent">
                                    See what's inside
                                </Button>                
                            </RouterLink>
                            <Button color="custom" className="transfer-button" type="button" onClick={this.copyDownloadLink} >Copy Download Link</Button>
                        </div>
                        <div className={classes.transferFooter+" "+classes.uploadingProgressFooter}>
                            <RouterLink to={"/"} className={classes.dropdownLink}>
                                <Button color="custom" className="transfer-button" type="button" onClick={this.sendAnother} >Send another?</Button>
                            </RouterLink>
                        </div>
                    </div>
                    {
                        slider ?
                            <BackgroundSlider store={this.store} />
                        :
                        <></>
                    }
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        className={classes.snackbar}
                        open={this.state.snackbarOpen}
                        autoHideDuration={1000}
                        onClose={this.closeSnackbar}
                        ContentProps={{
                            'aria-describedby': 'message-id',
                        }}
                        message={<span id="message-id">Your link has been copied</span>}
                        action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className={classes.close}
                            onClick={this.closeSnackbar}
                        >
                            <CloseIcon />
                        </IconButton>,
                        ]}
                    />
                </div>
            );
        }
        if(uploading && this.isMyDocsSource()){
            return (
                <div className={classes.landingPageContainer}>
                    <div className={classes.transferForm+" transferFormUploading "+classes.uploadingProgress}>
                        <div className={classes.uploadingContent} role="status" aria-live="polite">
                            {
                                showError ?
                                    this.renderErrorMessages()
                                :
                                    <>
                                        <LoaderComponent color="custom" align="center" />
                                        <h2>Preparing your secure link</h2>
                                        {
                                            transferType === "email" ?
                                                <p className="orangeColor">Sharing {totalFiles} file{totalFiles === 1 ? "" : "s"} from My Docs with {recipients.length} recipient(s)</p>
                                            :
                                                <p className="orangeColor">Creating a link for {totalFiles} file{totalFiles === 1 ? "" : "s"} from My Docs</p>
                                        }
                                        <p>Nothing is uploaded again. File Attachment Rules are checked before the link is created.</p>
                                    </>
                            }
                        </div>
                        <div className={classes.transferFooter+" "+classes.uploadingProgressFooter}>
                            {
                                showError ?
                                    <Button color="custom" className="transfer-button" type="button" onClick={this.backToForm}>Back to edit</Button>
                                : null
                            }
                        </div>
                    </div>
                    {
                        slider ?
                            <BackgroundSlider store={this.store} />
                        :
                        <></>
                    }
                </div>
            );
        }
        if(uploading){
            return (
                <div className={classes.landingPageContainer}>
                    <div className={classes.transferForm+" transferFormUploading "+classes.uploadingProgress}>
                        <div className={classes.uploadingContent}>
                            <div className="transfer_loader">
                                <svg height="170" width="170" shapeRendering="geometricPrecision" viewBox="0 0 170 170">
                                    <circle className="loader__background" r="80" cx="85" cy="85" fill="transparent"style={{
                                        strokeDasharray: 502.655,
                                        strokeDashoffset: 0,
                                        strokeWidth: 10,
                                        stroke: "rgb(232, 235, 237)"
                                    }}></circle>
                                    <circle className="loader_foreground" r="80" cx="85" cy="85" fill="transparent" style={{
                                        strokeDasharray: 502.655,
                                        strokeDashoffset: progressOffset,
                                        strokeWidth: 10,
                                        stroke: "rgb(64, 159, 255)"
                                    }} ></circle>
                                </svg>
                                <span>{`${roundedValue}%`}</span>
                            </div>
                            {
                                showError ?
                                    this.renderErrorMessages()
                                :
                                    <>
                                <h2>Transferring</h2>
                                {
                                    transferType === "email" ?
                                        <p className="orangeColor">Sending {totalFiles} files to {recipients.length} recipient(s)</p>
                                    :
                                        <p className="orangeColor">Uploading {totalFiles} files and preparing link</p>
                                }
                                
                                <p>{helper.getFormatedSize(totalUploaded)} of {helper.getFormatedSize(totalSize)} uploaded</p>
                                </>
                            }
                            
                        </div>
                        <div className={classes.transferFooter+" "+classes.uploadingProgressFooter}>
                            {
                                resumable ?
                                    <Button color="custom" className="transfer-button" type="button" onClick={this.resumeUpload} >Resume</Button>
                                :
                                    <Button color="custom" className="transfer-button" type="button" onClick={this.cancelUpload} >Cancel</Button>
                            }
                            
                        </div>
                    </div>
                    {
                        slider ?
                            <BackgroundSlider store={this.store} />
                        :
                        <></>
                    }
                </div>
            );
        }
        const { far, farModal, dragOver, expirePreset, sourceTab, myDocsItems, myDocsResolving, myDocsError } = this.state;
        const isMyDocs = this.isMyDocsSource();
        const activeItems = this.getActiveItems();
        const farEvaluation = this.getFarEvaluation();
        const farDeferred = this.isFarDeferred();
        const farItems = farEvaluation ? farEvaluation.items : null;
        const showFarBanner = far.active && far.settings.show_status_banner !== false;
        const sendDisabledReason = this.getSendDisabledReason(farEvaluation);
        const farBlocking = !!(farEvaluation && farEvaluation.blocksSend);
        const showFarModal = !!(farModal && farEvaluation && farEvaluation.unresolvedPairs.length > 0);
        const canViewRules = authorized && user.user_type === "business" && user.level_id !== 5;
        let sendStatus = null;
        if(sendDisabledReason){
            sendStatus = sendDisabledReason;
        }else if(farEvaluation && farEvaluation.requiresAcknowledgement && farEvaluation.hasExclusions){
            sendStatus = "A recipient is blocked by a FAR exclusion. You'll be asked to confirm before sending.";
        }else if(farEvaluation && farEvaluation.requiresAcknowledgement){
            sendStatus = "Some recipients are not authorized for a matched file. You'll be asked to confirm before sending.";
        }else if(farEvaluation && farEvaluation.state === FAR_STATE.OVERRIDDEN){
            sendStatus = "Exceptions authorized. Ready to send.";
        }else if(farEvaluation && farEvaluation.state === FAR_STATE.AUTHORIZED){
            sendStatus = "File Attachment Rules check passed.";
        }else if(farDeferred && activeItems.length > 0){
            sendStatus = "Files and recipients will be checked against File Attachment Rules when you press Send.";
        }else if(transferType === "email" && recipients.length <= 0 && emailTo.length <= 0){
            sendStatus = "Add at least one recipient.";
        }
        return (
            <div className={classes.spPage}>
                <div className={classes.spHeader}>
                    <div className={classes.spHeaderText}>
                        <h1 className={classes.spTitle+" page-title"}>Start sending - it's that easy.</h1>
                        <p className={classes.spSubtitle}>Share files securely with anyone.</p>
                        <div className={classes.transferTypeLink}>
                        {
                            transferType === "link" ?
                                <Button simple color="transparent" onClick={(e) => this.toggleTransfer(e, "email")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 4190 4190">
                                        <path d="M85 4164c-16-9-39-28-50-42-20-27-20-45-23-1097-2-718 0-1082 7-1106 7-23 33-56 74-95 73-69 289-270 332-309 17-15 54-50 82-77l53-49 2-457 3-457 492-5 492-5 112-105c101-94 143-134 299-280 93-87 161-90 247-12 99 91 268 248 347 324l81 77 493 1h492v916l53 49c403 372 484 453 491 488 5 25 9 29 16 17 6-10 10 373 10 1060 0 591-4 1069-9 1062-6-10-10-5-14 17-7 33-37 68-76 89-18 9-437 12-2000 11-1745 0-1980-2-2006-15zm3853-158c8-9-14-34-98-111-47-43-126-117-176-164-49-47-141-133-204-191-62-58-128-118-145-135-210-196-270-252-285-265-18-15-232-216-375-350-44-42-111-105-149-140-39-36-108-101-155-146-47-44-108-100-136-125-27-24-65-58-84-76-20-17-40-29-47-25-21 13-174 152-414 377-47 44-146 136-220 205s-172 161-218 205c-47 44-90 85-96 90-7 6-43 39-81 75-39 36-135 126-215 200s-185 173-235 220c-49 46-121 114-160 150-167 156-208 198-202 206 5 9 3686 9 3695 0zM280 3878c138-133 509-482 555-523 115-101 365-342 365-351 0-12-24-36-200-200-46-43-128-119-180-169-109-103-476-446-564-526-32-30-64-54-70-54-8 0-12 260-14 948-2 897-1 947 15 947 10 0 52-33 93-72zm3730-878c0-670-3-950-11-950-6 0-47 35-93 78-238 224-371 349-390 365-12 10-79 74-151 141-71 68-152 143-179 167-112 100-206 194-206 205 0 7 15 24 33 39 17 15 64 57 102 94 39 36 140 131 225 211s164 154 176 165c11 11 54 51 95 89s106 98 144 134c39 36 105 98 147 139 43 40 84 73 93 73 13 0 15-103 15-950zm-1301-347c34-15 61-33 61-41 0-24-64-151-79-157-7-3-19-1-25 4-14 12-76 35-138 52-27 7-48 19-48 25 0 16 137 144 154 144 8 0 42-12 75-27zm-1076-40c27-27 59-56 69-66 26-24 20-37-27-55-176-68-295-212-357-429-19-68-22-103-22-278-1-191 13-335 36-360 4-5 8-19 8-31 0-13 5-26 10-29 6-3 10-12 10-20 0-30 76-143 135-200 121-118 299-180 550-192 160-8 372 27 485 79 141 66 256 192 305 334 51 148 70 304 62 504-11 253-27 280-158 280-64 0-74-3-95-26-13-14-25-26-26-27s-5-198-8-437l-5-435-80-12c-126-18-121-20-162 44l-36 56-19-26c-56-77-222-117-398-96-181 22-302 104-366 249-42 95-48 132-48 315-1 168 1 186 27 266 52 166 159 266 309 290 35 5 71 12 80 15 12 4 41-17 92-65 85-81 86-81 158-14l48 44 32-17c18-9 48-33 67-53 20-21 36-31 38-24 13 39 55 81 108 108 59 30 63 30 215 30 180 0 232-13 302-74 76-67 111-163 124-341 9-136 9-134 0-280-21-326-145-575-358-716-110-72-188-103-373-145-81-19-457-19-540-1-177 40-157 33-276 89-240 114-389 325-446 633-21 118-21 447 1 550 49 233 113 360 238 475 71 64 181 133 217 134 15 1 41-16 74-46zM560 1964c0-190-4-334-9-332-8 3-158 139-293 268-32 30-58 61-57 70 0 8 42 52 92 98 51 45 126 116 167 156s81 74 88 75c9 1 12-72 12-335zm3191 229c63-58 140-131 172-160 31-30 57-60 57-68 0-14-338-335-354-335-3 0-6 151-6 335s4 335 8 335c5 0 60-48 123-107zM2368 461c4-11-35-49-213-214-27-26-57-46-65-46-23 0-287 257-273 266 19 13 547 7 551-6z"/><path d="M1931 2058c-55-14-111-68-129-123-22-68-27-233-9-295 39-133 147-184 308-146 30 7 65 19 77 25 66 35 107 200 82 333-21 110-56 165-124 193-49 21-149 27-205 13z"/>
                                    </svg>
                                    Send Email?
                                </Button>
                            :
                                <Button simple color="transparent" onClick={(e) => this.toggleTransfer(e, "link")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 9800 9800">
                                        <path d="M7768 9785c-289-47-545-151-778-318-113-81-319-289-403-407-37-52-98-158-137-235-104-211-157-394-181-626l-12-117-915-528c-504-291-929-540-945-553l-29-24-40 49c-23 27-95 103-162 169-373 370-847 604-1381 682-179 26-514 23-701-5-700-108-1304-499-1695-1095-179-273-299-580-360-922-30-169-38-537-15-715 78-598 347-1113 791-1517 173-157 340-270 565-382 314-156 628-235 990-248 574-21 1120 152 1576 498l100 76 750-433c412-238 753-435 759-437 5-2-3-42-18-93-98-322-113-632-46-974 120-610 539-1151 1104-1425 205-100 391-157 616-190 140-20 424-20 570 1 675 94 1257 517 1554 1129 140 287 204 569 205 892 1 1067-792 1939-1859 2043-591 58-1185-159-1621-591l-81-80-697 403-697 402 76 152c170 340 249 681 249 1074 0 271-34 498-110 740-16 52-27 97-24 102 3 4 13 8 23 8 19 0 136 66 1023 578 344 199 630 362 635 362s17-17 27-37c32-69 163-257 239-343 249-283 586-477 977-562 92-19 134-22 335-23 201 0 244 3 343 23 719 146 1258 685 1404 1404 20 98 23 143 23 338s-3 240-23 338c-145 716-686 1259-1398 1403-140 28-471 36-606 14zm402-820c207-31 376-118 530-274 113-114 178-217 226-359 182-530-136-1093-694-1229-103-25-304-23-415 5-225 56-424 189-553 368-62 87-130 234-155 340-31 124-31 304 0 428 23 96 89 245 142 322 92 134 258 271 405 333 171 73 334 94 514 66zM2768 7042c582-127 1040-531 1222-1081 160-482 97-976-177-1401-237-366-605-616-1046-712-88-19-132-22-317-22-237 0-318 12-511 74-535 175-962 650-1079 1203-76 355-35 706 120 1035 233 492 684 828 1229 917 126 21 436 13 559-13zm4880-3793c220-26 463-136 637-289 350-307 495-776 380-1227-32-123-123-311-203-418-347-465-972-622-1489-375-253 120-445 307-568 550-100 199-140 372-139 600 0 126 5 172 24 250 51 212 146 388 290 543 109 117 217 197 356 264 222 107 425 136 712 102z"/>
                                    </svg>
                                    Need just a link? 
                                </Button>
                        }
                    </div>
                    </div>
                    {
                        showFarBanner ?
                            <div className={classes.spBanner}>
                                <FarStatusBanner variant="send" onViewRules={canViewRules ? () => this.history.push("/attachment/rules") : null} />
                            </div>
                        : null
                    }
                </div>
                <div className={classes.spLayout}>
                    <div className={classes.spMain+" "+classes.homepageFormFields+" uploader-fields"}>
                        {
                            showPwnedError || foundPwned ?
                                <GridContainer>
                                    { this.renderErrorMessages() }
                                </GridContainer>
                            : pwnedSuccessMessage !== '' ?
                                <GridContainer>
                                    <GridItem className={"passwordCheck-valid-customizable"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#10003;</span>
                                        <span className="checkPasswordText-lowerletter">{ pwnedSuccessMessage }</span>
                                    </GridItem>
                                </GridContainer>
                            :
                                <></>
                        }
                        <section className={classes.spCard} aria-labelledby="sp-recipients-title">
                            <h2 className={classes.spCardTitle} id="sp-recipients-title"><PeopleOutline aria-hidden="true" />{transferType === "email" ? "Recipients" : "Sender"}</h2>
                            {
                                transferType === "email" ?
                                    <div className="formElement">
                                        <label className={classes.spLabel} htmlFor="email">To</label>
                                        {
                                            recipients.length > 0 ?
                                                <div className={"react-tagsinput "+classes.tagsInput}>
                                                    <div className="users-icon">
                                                        <MaterialIcon path={mdiAccountGroup} />
                                                    </div>
                                                    <div className="users-lists" role="list" aria-label="Recipients">
                                                        {
                                                            recipients.map((email, key) => {
                                                                const isBreached = breachedEmails.includes(email);
                                                                const farStatus = this.getRecipientFarStatus(email, farEvaluation);
                                                                const highlight = (farStatus === "bad" && far.settings.highlight_invalid_recipients !== false) || farStatus === "blocked";
                                                                const exclusionText = farStatus === "blocked" ? describeExclusion(farEvaluation.excludedRecipients[String(email).toLowerCase()]) : null;
                                                                return (
                                                                    <span role="listitem" className={`react-tagsinput-tag ${isBreached ? 'breached' : 'rose'} ${highlight ? classes.spChipUnauthorized : ''}`} key={key} title={exclusionText || undefined}>
                                                                        {
                                                                            farStatus === "blocked" ?
                                                                                <BlockIcon className={classes.spChipIcon+" "+classes.spChipBad} aria-label={exclusionText} role="img" />
                                                                            : farStatus === "ok" ?
                                                                                <CheckCircle className={classes.spChipIcon+" "+classes.spChipOk} aria-label="Authorized" role="img" />
                                                                            : farStatus === "bad" ?
                                                                                <ErrorOutline className={classes.spChipIcon+" "+classes.spChipBad} aria-label="Not authorized" role="img" />
                                                                            : farStatus === "warn" ?
                                                                                <ReportProblemOutlined className={classes.spChipIcon+" "+classes.spChipWarn} aria-label="Exception authorized" role="img" />
                                                                            : null
                                                                        }
                                                                        <span onClick={(e) => this.editRecipient(e, email)}>{email}</span>
                                                                        <a href="/" aria-label={"Remove "+email} onClick={(e) => this.removeRecipient(e, email)}>&nbsp;</a>
                                                                    </span>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            :
                                            <></>
                                        }
                                        <div className={classes.spRecipientInputRow}>
                                        <CustomInput
                                            id="email"
                                            success={emailSuccess}
                                            error={emailError}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            labelText="user@example.com"
                                            inputProps={{
                                                type: "email",
                                                onChange: (e) => this.handleChange(e, 'emailTo'),
                                                name: "emailTo",
                                                value: emailTo,
                                                onKeyUp: (e) => this.onEmailKeyUp(e),
                                                onBlur: () => this.onEmailKeyUp(null),
                                                onKeyDown: (e) => this.onEmailKeyUp(e),
                                                "aria-describedby": "sp-recipients-help"
                                            }}
                                        />
                                        {
                                            authorized ?
                                                <button type="button" className={classes.spContactsButton} onClick={() => this.onAddressBook(true)}
                                                    title="Select from contacts" aria-label="Select recipients from contacts" aria-haspopup="dialog">
                                                    <ContactsOutlined aria-hidden="true" />
                                                </button>
                                            :
                                                null
                                        }
                                        </div>
                                        <div className={classes.spHelperRow+" havebeenpwned"}>
                                            <p className="recipients-description" id="sp-recipients-help">Press TAB or ENTER after each email{ authorized ? ", or select from your contacts" : "" }.</p>
                                            {
                                                authorized && user.extensions.have_i_been_pwned.status && (user.extensions.have_i_been_pwned.path !== null || user.extensions.have_i_been_pwned.path !== '') ?
                                                    <Button color="custom" size="sm" onClick={() => this.haveBeenPwned()} disabled={checkingpwned ? true: false}>
                                                        {
                                                            checkingpwned ?
                                                                <LoaderComponent color="white" saving={true} />
                                                            :
                                                                "Security Check"
                                                        }
                                                    </Button>
                                                :
                                                    <></>
                                            }
                                        </div>
                                    </div>
                                :
                                    <></>
                            }
                            <div className={"formElement "+classes.spFrom}>
                                <label className={classes.spLabel} htmlFor="outlined-yourEmail">From{ authorized ? <span className={classes.spLabelMuted}> (your account)</span> : null }</label>
                                <CustomInput
                                    id="outlined-yourEmail"
                                    success={validation.yourEmail === "success"}
                                    error={validation.yourEmail === "error"}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    labelText="you@example.com"
                                    inputProps={{
                                        type: "email",
                                        onChange: (e) => this.handleChange(e, 'yourEmail'),
                                        name: "yourEmail",
                                        value: yourEmail,
                                        disabled: (authorized ? true : false)
                                    }}
                                />
                            </div>
                        </section>

                        <section className={classes.spCard} aria-labelledby="sp-security-title">
                            <h2 className={classes.spCardTitle} id="sp-security-title"><SecurityIcon aria-hidden="true" />Security options</h2>
                            <div className={classes.spTwoCol}>
                                <div className="formElement passwordElement">
                                    <label className={classes.spLabel} htmlFor="input-password">Link password <span className={classes.spLabelMuted}>(optional)</span></label>
                                    <CustomInput
                                        labelText="Enter a password"
                                        id="input-password"
                                        passwordInput={viewPassword ? false : true}
                                        inputProps={{
                                            value: linkPassword,
                                            name: "linkPassword",
                                            type: "text",
                                            onChange: (e) => this.handleChange(e, 'linkPassword'),
                                            autoComplete: 'off',
                                            endAdornment: (
                                                <InputAdornment 
                                                    className={classes.inputAdornment+' viewPasswordIcon'} 
                                                    onClick={() => this.onViewPassword('viewPassword')}
                                                    position='end'
                                                    aria-label={viewPassword ? "Hide password" : "Show password"}
                                                >
                                                    {
                                                        this.state.linkPassword ?
                                                            viewPassword ?
                                                                <VisibilityOffIcon className={classes.inputAdornmentIcon}/>
                                                            :
                                                                <VisibilityIcon className={classes.inputAdornmentIcon}/>
                                                        :
                                                            <></>
                                                    }
                                                </InputAdornment>
                                            ),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                    />
                                </div>
                                <div className="formElement dateElement">
                                    <label className={classes.spLabel} htmlFor="input-expire">Expiry date <span className={classes.spLabelMuted}>(optional)</span></label>
                                    <DateTimePicker
                                        labelText="Select a date"
                                        id="input-expire"
                                        value={expire}
                                        onChange={(date) => { this.handleDateChange(date, 'expire'); this.setState({ expirePreset: null }); }}
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        disablePast={true}
                                    />
                                    {
                                        expire && expire !== null ?
                                            <Button justIcon color="custom" className="clear-icon" onClick={() => { this.onClearDate(); this.setState({ expirePreset: null }); }} aria-label="Clear expiry date">
                                                <svg width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.4082 14.4527C11.6262 14.6707 11.9848 14.6707 12.2027 14.4527C12.4207 14.2348 12.4207 13.8762 12.2027 13.6582L7.54453 9L12.2027 4.3418C12.4207 4.12383 12.4207 3.76523 12.2027 3.54727C11.9848 3.3293 11.6262 3.3293 11.4082 3.54727L6.75 8.20547L2.09531 3.54727C1.87734 3.3293 1.51875 3.3293 1.30078 3.54727C1.08281 3.76523 1.08281 4.12383 1.30078 4.3418L5.95547 9L1.29727 13.6582C1.0793 13.8762 1.0793 14.2348 1.29727 14.4527C1.51523 14.6707 1.87383 14.6707 2.0918 14.4527L6.75 9.79453L11.4082 14.4527Z"/>
                                                </svg>
                                            </Button>
                                        :
                                            <></>
                                    }
                                    <div className={classes.spPresets} role="group" aria-label="Expiry presets">
                                        {
                                            [7, 14, 30].map(days => (
                                                <button type="button" key={days} className={classes.spPreset} aria-pressed={expirePreset === days ? "true" : "false"} onClick={() => this.setExpiryPreset(days)}>
                                                    {days} days
                                                </button>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                transferType === "email" ?
                                    <div className={"formElement "+classes.spCheckRow}>
                                        <FormControlLabel
                                            classes={{label: classes.label}}
                                            style={{alignItems: "flex-start", textAlign: "left", margin: "0px"}}
                                            control={
                                                <Checkbox
                                                    tabIndex={0}
                                                    onClick={(e) => this.handleCheckbox(e, "requireVerification")}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{checked: classes.checked, root: classes.checkRoot}}
                                                    checked={requireVerification ? true : false}
                                                    inputProps={{ "aria-describedby": "sp-verify-help" }}
                                                />
                                            }
                                            label="Require recipients to verify their email"
                                        />
                                        <p className={classes.spCheckHelp} id="sp-verify-help">Recipients confirm their address with a one-time code or link before they can open the files.</p>
                                    </div>
                                :
                                    <></>
                            }
                        </section>

                        {
                            transferType === "email" ?
                                <section className={classes.spCard} aria-labelledby="sp-message-title">
                                    <h2 className={classes.spCardTitle} id="sp-message-title"><ChatBubbleOutline aria-hidden="true" />Message <span className={classes.spLabelMuted}>(optional)</span></h2>
                                    <div className="formElement">
                                        <div className={classes.editor}>
                                            <RichTextEditor 
                                                toolbarConfig={this.getConfig()} 
                                                customControls={this.getCustomControls()}
                                                onChange={(content) => this.handleMessageChange(content, "message")}
                                                value={message}
                                                toolbarClassName="sd-editor-toolbar"
                                                placeholder="Add a message…"
                                            />
                                            <div className={classes.hidden} id="placeholder-3b60g"></div>
                                            <div className={classes.hidden} id="placeholder-crl20"></div>
                                        </div>
                                    </div>
                                </section>
                            :
                                <></>
                        }

                        <section className={classes.spCard} aria-labelledby="sp-files-title">
                            <div className={classes.spFilesHead}>
                                <h2 className={classes.spCardTitle} id="sp-files-title"><AttachFile aria-hidden="true" />Files{ isMyDocs ? (myDocsItems.length > 0 ? " ("+this.getMyDocsCount()+")" : "") : (files.length > 0 ? " ("+filesCount+")" : "") }</h2>
                                {
                                    isMyDocs ?
                                        (myDocsItems.length > 0 ? <span>{helper.getFormatedSize(this.getMyDocsSize())} from My Docs · no upload needed</span> : null)
                                    :
                                        (files.length > 0 ? <span>{helper.getFormatedSize(this.getTotalSize())} added · {helper.getFormatedSize(remainingSize)} remaining</span> : null)
                                }
                            </div>
                            <div className={classes.spSources} role="group" aria-label="Choose where the files come from">
                                <button type="button" className={classes.spSource} aria-pressed={sourceTab === "files" ? "true" : "false"} onClick={() => this.onSourceSelect("files")}>
                                    <CloudUploadOutlined aria-hidden="true" />
                                    <span><strong>Upload Files</strong><small>Select files from your computer</small></span>
                                </button>
                                <button type="button" className={classes.spSource} aria-pressed={sourceTab === "folder" ? "true" : "false"} onClick={() => this.onSourceSelect("folder")}>
                                    <FolderOpenIcon aria-hidden="true" />
                                    <span><strong>Select a Folder</strong><small>Share an entire folder</small></span>
                                </button>
                                {
                                    authorized ?
                                        <button type="button" className={classes.spSource} aria-pressed={isMyDocs ? "true" : "false"} onClick={() => this.onSourceSelect("mydocs")}>
                                            <DescriptionOutlined aria-hidden="true" />
                                            <span><strong>My Docs</strong><small>Choose files from your Sendlinx My Docs</small></span>
                                        </button>
                                    : null
                                }
                            </div>
                            {/* Kept mounted (hidden) so the source buttons can open the file and folder dialogs. */}
                            <div className={classes.spUploaderHidden} aria-hidden="true">
                                <CustomFileUpload
                                    id="outlined-fileUpload"
                                    multiple={true}
                                    onChange={(files) => this.onFilesSelect(files)}
                                    files={files}
                                    store={this.store}
                                    ref={this.uploaderRef}
                                />
                            </div>
                            {
                                isMyDocs ?
                                    <div className={classes.spDropZone+" "+(dragOver ? classes.spDropActive : "")}
                                        onDragOver={this.onDragOver} onDragEnter={this.onDragOver} onDragLeave={this.onDragLeave} onDrop={this.onDrop}>
                                        <button type="button" className={classes.spBrowseButton} onClick={() => this.setState({ myDocsPicker: true })} disabled={myDocsResolving}>
                                            <DescriptionOutlined aria-hidden="true" />{ myDocsItems.length > 0 ? "Add or change My Docs files" : "Browse My Docs" }
                                        </button>
                                        <p className={classes.spDropHint}>Pick files or folders already stored in Sendlinx. They are shared as a secure link without uploading them again.</p>
                                    </div>
                                :
                                    <div className={classes.spDropZone+" "+(dragOver ? classes.spDropActive : "")+" uploader-files"}
                                        onDragOver={this.onDragOver} onDragEnter={this.onDragOver} onDragLeave={this.onDragLeave} onDrop={this.onDrop}>
                                        <p className={classes.spDropHint}>
                                            Drag and drop files here, or{" "}
                                            <button type="button" className={classes.spLinkButton} onClick={() => this.onSourceSelect(sourceTab === "folder" ? "folder" : "files")}>
                                                { sourceTab === "folder" ? "choose a folder" : "browse your computer" }
                                            </button>.
                                        </p>
                                    </div>
                            }
                            {
                                isMyDocs && files.length > 0 ?
                                    <p className={classes.spSourceNote}>{filesCount} file{filesCount === 1 ? "" : "s"} you added from your computer {filesCount === 1 ? "is" : "are"} kept aside and won't be sent with My Docs files.</p>
                                : !isMyDocs && myDocsItems.length > 0 ?
                                    <p className={classes.spSourceNote}>{myDocsItems.length} My Docs item{myDocsItems.length === 1 ? " is" : "s are"} kept aside and won't be sent with uploaded files. Choose My Docs to send {myDocsItems.length === 1 ? "it" : "them"}.</p>
                                : null
                            }
                            { isMyDocs && myDocsResolving ? <div role="status" aria-live="polite"><LoaderComponent color="custom" align="center" /></div> : null }
                            { isMyDocs && myDocsError ? <div className={classes.spMessage} role="alert"><p>{myDocsError}</p></div> : null }
                            {
                                isMyDocs ?
                                    (myDocsItems.length > 0 ?
                                        <ul className={classes.spFileList} aria-label="Selected My Docs files">
                                            { myDocsItems.map((item, key) => this.renderMyDocsItem(item, key, farItems ? farItems[key] : null)) }
                                        </ul>
                                    : null)
                                : files.length > 0 ?
                                    <ul className={classes.spFileList} aria-label="Selected files">
                                        { files.map((item, key) => this.renderSendFile(item, key, farItems ? farItems[key] : null)) }
                                    </ul>
                                :
                                    <></>
                            }
                            {
                                isMyDocs ?
                                    null
                                : authorized && (user.quota - user.usage) < this.getTotalSize() ?
                                    <div className={classes.spMessage} role="alert">
                                        <p>Your upload exceeds the maximum allowed quota of {helper.getFormatedSize(user.quota)}. Your current remaining storage is {helper.getFormatedSize(user.quota - user.usage)}.</p>
                                    </div>
                                : maxSize < this.getTotalSize() ?
                                    <div className={classes.spMessage} role="alert">
                                        <p>Your upload exceeds the maximum allowed quota of {helper.getFormatedSize(maxSize)}.</p>
                                    </div>
                                :
                                    <></>
                            }
                            {
                                !isMyDocs && this.getTotalSize() > maxFileUploadSize ?
                                    <div className={classes.spMessage} role="alert">
                                        <p>Your file exceeds to {helper.getFormatedSize(maxFileUploadSize)}. Max limit per file size is {helper.getFormatedSize(maxFileUploadSize)}.</p>
                                    </div>
                                :
                                    <></>
                            }
                            {
                                showZipUploadCheckbox && !isMyDocs ?
                                    <div className={classes.spZipRow+" "+classes.homeFileSendingForm} style={{borderTop: "none", justifyContent: "flex-start"}}>
                                        <div className="labelElement">
                                            <FormControlLabel
                                                classes={{label: classes.label}}
                                                control={
                                                    <Checkbox
                                                        tabIndex={0}
                                                        onClick={(e) => this.handleCheckbox(e, "zipUpload")}
                                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                                        icon={<Check className={classes.uncheckedIcon} />}
                                                        classes={{checked: classes.checked, root: classes.checkRoot}}
                                                        checked={zipUpload}
                                                        disabled={zipCheckboxDisabledStatus}
                                                    />
                                                }
                                                label={"Zip files"}
                                            />
                                        </div>
                                        {
                                            zipUpload ?
                                                <div className="lockElement">
                                                    <IconButton
                                                        key="lock"
                                                        aria-label={zipPasswordToggle ? "Remove zip password" : "Add zip password"}
                                                        color="inherit"
                                                        className={classes.lock}
                                                        onClick={() => this.handlePasswordToggle()}
                                                        title={zipPasswordToggle ? "UnLock the Zip File" : "Lock the Zip File"}
                                                    >
                                                        <LockOpenIcon />
                                                    </IconButton>
                                                </div>
                                            :
                                                <></>
                                        }
                                    </div>
                                :
                                <></>
                            }
                            {
                                zipPasswordToggle && !isMyDocs ?
                                    <div className={"formElement passwordElement "+classes.spZipPassword}>
                                        <label className={classes.spLabel} htmlFor="input-zipPassword">Zip password</label>
                                        <CustomInput
                                            labelText="Enter a zip password"
                                            formControlProps={{
                                                fullWidth: true,
                                            }}
                                            id="input-zipPassword"   
                                            passwordInput={viewZipPassword ? false : true}                                     
                                            inputProps={{
                                                onChange: (e) => this.handleChange(e,'zipPassword'),
                                                name: "zipPassword",
                                                type: "text",
                                                value: zipPassword,
                                                autoComplete: 'off',
                                                endAdornment: (
                                                    <InputAdornment 
                                                        className={classes.inputAdornment+' viewPasswordIcon'} 
                                                        onClick={() => this.onViewPassword('viewZipPassword') }
                                                        position='end'
                                                    >
                                                        {
                                                            this.state.zipPassword ?
                                                                viewZipPassword ?
                                                                    <VisibilityOffIcon className={classes.inputAdornmentIcon}/>
                                                                :
                                                                    <VisibilityIcon className={classes.inputAdornmentIcon}/>
                                                            :
                                                                <></>
                                                        }
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </div>
                                :
                                <></>
                            }
                        </section>

                        <div className={classes.spSendBar}>
                            <p className={classes.spSendStatus} role="status" aria-live="polite" id="sp-send-status">{sendStatus}</p>
                            <div className={classes.spSendButtons}>
                                {
                                    farBlocking ?
                                        <button type="button" className={classes.spException} onClick={() => this.setState({ farModal: "resolve" })}>
                                            {farEvaluation.canResolveAll ? "Authorize Exception" : "Review Recipients"}
                                        </button>
                                    : null
                                }
                                <button type="button" className={classes.spSend} onClick={this.onSendClick} disabled={sendDisabledReason !== null}
                                    aria-describedby={sendStatus ? "sp-send-status" : undefined}>
                                    <svg className="sendicon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 3760 3500">
                                        <path d="M970 3489c-52-16-86-45-108-92-19-39-178-874-169-883 8-8 888 629 884 640-3 12-423 297-472 320-43 21-95 26-135 15zm1322-152c-40-15-1104-787-1100-798 2-5 379-378 838-830C3215 542 3575 185 3559 195c-8 5-614 481-1348 1059-734 577-1339 1049-1345 1049-13 0-743-529-790-572-67-61-89-186-47-268 45-90-23-61 1743-738C2675 379 3472 74 3542 48c138-53 167-54 195-11 9 13 16 36 15 51-1 19-1046 2900-1130 3113-18 45-74 101-127 125-56 27-146 31-203 11z"/>
                                    </svg>
                                    {transferType === "email" ? "Send" : "Get a link" }
                                </button>
                            </div>
                        </div>
                        {
                            upgradeModal ?
                                this.renderConfirmationModal()
                            :
                            null
                        }
                    </div>
                    <aside className={classes.spSide} aria-label="Transfer status">
                        {
                            far.active ?
                                <FarCheckPanel
                                    evaluation={farEvaluation}
                                    loading={far.loading}
                                    error={far.error}
                                    onRetry={this.loadFarConfig}
                                    hasFiles={activeItems.length > 0}
                                    deferred={farDeferred}
                                    onLearnMore={canViewRules ? () => this.history.push("/attachment/rules?tab=settings") : null}
                                />
                            :
                                this.renderTransferSummary()
                        }
                    </aside>
                </div>
                {
                    showFarModal ?
                        <FarExceptionModal
                            open={true}
                            evaluation={farEvaluation}
                            canOverride={far.canOverride}
                            isAdmin={!!far.isAdmin}
                            acknowledgeMode={farModal === "acknowledge"}
                            transferType={transferType}
                            onClose={() => this.setState({ farModal: null })}
                            onRemoveRecipients={this.onFarRemoveRecipients}
                            onResolve={this.onFarResolve}
                        />
                    : null
                }
                {
                    this.state.myDocsPicker ?
                        <MyDocsPickerModal
                            open={this.state.myDocsPicker}
                            mode="items"
                            title="Select from My Docs"
                            subtitle="Choose files or folders to share. They are sent as a secure link without uploading them again."
                            selected={myDocsItems}
                            onClose={() => this.setState({ myDocsPicker: false })}
                            onSelect={this.onMyDocsPicked}
                        />
                    : null
                }
                {
                    this.state.addressBookModal ?
                        <AddressBookModal
                            open={this.state.addressBookModal}
                            onClose={() => this.onAddressBook(false)}
                            onAdd={this.onAddressBookAdd}
                            existingRecipients={this.state.recipients}
                            initialView={this.state.addressBookView}
                            user={this.store.getState().user}
                            onOpenExtensions={this.history ? () => { this.onAddressBook(false); this.history.push("/user/extensions"); } : null}
                        />
                    : null
                }
                {
                    zipConfirmationModal ?
                        <ZipConfirmationModal 
                            open={zipConfirmationModal} 
                            onClose={() => this.onZipModalSuccess(false)} 
                            onSuccess={() => this.onZipModalSuccess(true)}
                            confirmationMessage={zipConfirmationMessage}
                        />
                    :
                        <></>
                }
                {
                    sendLimitModal ?
                        <SendLimitModal
                            open={sendLimitModal}
                            onClose={() => this.setState({ sendLimitModal: false })}
                            store={this.store}
                        />
                    :
                        <></>
                }
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}


Home.defaultProps = {
    slider: true
}

Home.propTypes = {
    classes: PropTypes.object,
    slider: PropTypes.bool
};

export default withStyles(theme => ({ ...homePageStyle(theme), ...sendPageStyle(theme) }))(Home);
